<script lang="ts">
	import { PUBLIC_ENVIRONMENT } from '$env/static/public';

	export let email: string;
</script>

{#if PUBLIC_ENVIRONMENT === 'prod'}
	<a
		class="w-fit h-12 px-3 flex flex-row justify-center items-center text-center rounded text-sm font-semibold
		text-zinc-900 bg-primary-50 border border-primary-200 hover:brightness-90
		dark:text-zinc-200 dark:hover:bg-cyan-300 dark:border-none dark:hover:bg-opacity-10 dark:bg-zinc-800"
		href="https://billing.stripe.com/p/login/4gw02Pdrx5vv4k88ww?prefilled_email={email}"
		target="_blank"
	>
		Manage subscription
	</a>
{:else if PUBLIC_ENVIRONMENT === 'dev' || PUBLIC_ENVIRONMENT === 'local'}
	<a
		class="w-fit h-12 px-3 flex flex-row justify-center items-center text-center rounded text-sm font-semibold
		text-zinc-900 bg-primary-50 border border-primary-200 hover:brightness-90
		dark:text-zinc-200 dark:hover:bg-cyan-300 dark:border-none dark:hover:bg-opacity-10 dark:bg-zinc-800"
		href="https://billing.stripe.com/p/login/test_14k5kyaRt8aAgQ8aEE?prefilled_email={email}"
		target="_blank"
	>
		Manage subscription
	</a>
{/if}
